import {
  AccountEnvironment,
  Page,
  UserRepresentation,
  getPersonalInfo,
  useEnvironment,
  usePromise,
} from "@keycloak/keycloak-account-ui";
// import { Button } from "@patternfly/react-core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

type ActionButtonProps = {
  label: string;
  path: string;
  id: string;
  action: React.MouseEventHandler<HTMLAnchorElement>;
};

function ActionButton({ label, path, action }:ActionButtonProps){
  return (
    <div className="pf-v5-l-gallery__item">
      <div className="nc-menue_helptext">
        <p>{/* マージンのため？？ */} </p>
      </div>
        <div className="changeButton">
          <NavLink
            to={path}
            target="_blank"
            onClick={action}
          >{label}</NavLink>
        </div>
    </div>     
  );
};

export const Email = () => {
  const { t } = useTranslation();
  const context = useEnvironment<AccountEnvironment>();
  const [personalInfo, setPersonalInfo] = useState<UserRepresentation>();
  const keycloak = context.keycloak;
  const requiredActionId = "modify-email-provider";

  usePromise((signal) => getPersonalInfo({ signal, context }), setPersonalInfo);

   return (
    <Page
      title={t("emailPage.title")}
      description={""}
    >
      <div className="pf-c-data-list__item-row pf-u-align-items-center">
        <div className={"Email-page_main-body"}>
          <span className="Email-subTitle">{t("emailPage.displayname")}</span>
          <div className={"Email-area"}>
            <div className={"Email-list-item"}>
              <span className="Email-label">{t("emailPage.currentEmail_title")}</span>
              <div className="pf-c-data-list__cell">
                <span className="Email-info">{personalInfo?.email}</span>
              </div>
            </div>
          <div className="pf-c-data-list__cell"></div>
            <span style={{float: "right"}}>
              <ActionButton label={t("emailPage.button_change")} path="" action={()=>{keycloak.login( {action: requiredActionId} )}} id="save-btn" />
            </span>
          </div>
        </div>
      </div>  
    </Page>
  );
};
